import Vue from "vue";

const getDefaultState = () => {
  return {
    FormationsDeGroupe: [],
    formationsDeGroupeRegion: [],
    //field: "name",
    whereField: "responsable",
    //whereValue: "superviseur",
    collection: "formationsDeGroupe",
  };
};
const state = getDefaultState();

const mutations = {
  SET_LISTE(state, payload) {
    state.FormationsDeGroupe = payload;
  },
  SET_LISTE_FORMATION_DE_GROUPE_DE_REGIONS(state, payload) {
    state.formationsDeGroupeRegion = payload;
  },

  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  ADD_ONE_ITEM(state, payload) {
    state.FormationsDeGroupe.push(payload);
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  addOneItem({ commit }, item) {
    commit("ADD_ONE_ITEM", item);
    console.log("added to Vuex formations de groupe", item)
  },
  async getFormationsDeGroupesderegions({ commit }, arrayRegions) {
    let self = this;
    let formationsDeGroupeRegion = [];
    self._vm.$vloading.show();
    this._vm.$firebase
      .firestore()
      .collection("formationsDeGroupe")
      .where("id_region", "in", arrayRegions)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          // console.log(doc.id, " => ", doc.data());
          formationsDeGroupeRegion.push({
            ...doc.data(),
            id: doc.id,
          });
        });
        commit(
          "SET_LISTE_FORMATION_DE_GROUPE_DE_REGIONS",
          formationsDeGroupeRegion
        );
        self._vm.$vloading.hide();
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  },
  GetFormationsDuSuperviseur({ commit, state }, objet) {
    console.log("************",objet)
    // start requête
    commit("SET_LISTE", []);
    commit("RESET_STATE");
    commit("Loading/START_BUSY_STATE", "FormationsDeGroupe GetAll", {
      root: true,
    });

 
    let elemsTemp = [];
    this._vm.$firebase
      .firestore()
      .collection(this.state.FormationsDeGroupe.collection)
      .where(this.state.FormationsDeGroupe.whereField, "==", objet.userId)
      .where('programmes_id_programme', "==", objet.project.id)
      .where("date_formation_groupe", ">=", objet.start)
      .where("date_formation_groupe", "<=", objet.end)
      .orderBy("date_formation_groupe", "desc")
      .get()
      .then(
        (snapshot) => {
          if (snapshot.metadata.hasPendingWrites) {
            console.log("il en reste");
            commit("Pending/START_PENDING_STATE", "FormationsDeGroupe GetAll", {
              root: true,
            });
          } else {
            console.log("tout est synchronisé Dans FormationsDeGroupe GetAll");
            commit("Pending/END_PENDING_STATE", "FormationsDeGroupe GetAll", {
              root: true,
            });
          }

          snapshot.forEach(function (doc) {
            elemsTemp.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elemsTemp) {
            let text = "No Data Available";
            console.log(text);
            //start set snackbar
            let snack = {};
            snack.showSnackbar = true;
            snack.snackbarContent = text;
            commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
            //End set snackbar
            return false;
          } else {
            //arrayProjetsDeAnimateur
      /*       let arrayProjetsDeAnimateur = [];
            this.state.Auth.user.projets.forEach(function (item) {
              arrayProjetsDeAnimateur.push(item.id);
            }); */

            //projetsDesCampagnesActivesEtDelAnimateur
    /*         let projetsDesCampagnesActivesEtDelAnimateur = _.difference(
              arrayProjetsDeAnimateur,
              this.state.Campagnes.ProjetsOfCampagnesActives
            ); */

         /*    let start = new Date(this.state.Campagnes.startDate);
            let end = new Date(this.state.Campagnes.endDate);
            /// à vérifier
            elemsTemp.filter((item) => {
              let date = new Date(item.date_formation_groupe);
              return date >= start && date <= end;
            });

            var definitive = _.filter(elemsTemp, (v) =>
              _.includes(
                arrayProjetsDeAnimateur,
                v.programmes_id_programme
              )
            ); */

            commit("SET_LISTE", elemsTemp);
            commit("Loading/END_BUSY_STATE", "FormationsDeGroupe.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit("Loading/END_BUSY_STATE", "FormationsDeGroupe.store.js", {
            root: true,
          });
        }
      );
  },
  async GetFormationsDeGroupe({ commit }, idGroupe) {
    // start requête
    commit("SET_LISTE", []);
    commit("RESET_STATE");
    commit("Loading/START_BUSY_STATE", "FormationsDeGroupe GetAll", {
      root: true,
    });

    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection(this.state.FormationsDeGroupe.collection)
      .where("groupes_code_groupe", "==", idGroupe)
      .orderBy("date_formation_groupe", "desc")
      .get()
      .then(
        (snapshot) => {
          if (snapshot.metadata.hasPendingWrites) {
            console.log("il en reste");
            commit("Pending/START_PENDING_STATE", "FormationsDeGroupe GetAll", {
              root: true,
            });
          } else {
            console.log("tout est synchronisé Dans FormationsDeGroupe GetAll");
            commit("Pending/END_PENDING_STATE", "FormationsDeGroupe GetAll", {
              root: true,
            });
          }

          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            let text = "No Data Available";
            console.log(text);
            //start set snackbar
            let snack = {};
            snack.showSnackbar = true;
            snack.snackbarContent = text;
            commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
            //End set snackbar
            return false;
          } else {
            commit("SET_LISTE", elems);
            commit("Loading/END_BUSY_STATE", "FormationsDeGroupe.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit("Loading/END_BUSY_STATE", "FormationsDeGroupe.store.js", {
            root: true,
          });
        }
      );
  },
  async GetAll({ commit }) {
    // start requête
    commit("SET_LISTE", []);
    commit("RESET_STATE");
    commit("Loading/START_BUSY_STATE", "FormationsDeGroupe GetAll", {
      root: true,
    });

    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection(this.state.FormationsDeGroupe.collection)
      .get()
      .then(
        (snapshot) => {
          if (snapshot.metadata.hasPendingWrites) {
            console.log("il en reste");
            commit("Pending/START_PENDING_STATE", "FormationsDeGroupe GetAll", {
              root: true,
            });
          } else {
            console.log("tout est synchronisé Dans FormationsDeGroupe GetAll");
            commit("Pending/END_PENDING_STATE", "FormationsDeGroupe GetAll", {
              root: true,
            });
          }

          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            let text = "No Data Available";
            console.log(text);
            //start set snackbar
            let snack = {};
            snack.showSnackbar = true;
            snack.snackbarContent = text;
            commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
            //End set snackbar
            return false;
          } else {
            commit("SET_LISTE", elems);
            commit("Loading/END_BUSY_STATE", "FormationsDeGroupe.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit("Loading/END_BUSY_STATE", "FormationsDeGroupe.store.js", {
            root: true,
          });
        }
      );
  },
};

const getters = {
  FormationsDeGroupe: (state) => {
    return state.FormationsDeGroupe;
  },
  formationsDeGroupeRegion: (state) => {
    return state.formationsDeGroupeRegion;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
